import React, { useEffect, useState } from 'react';
import ReddyLayout from '../components/home/ReddyLayout';
import { useReddyAuth } from '../components/home/ReddyAuth';
import { SIDEBAR_ITEMS } from '../data/homeData';

const COLS = ['No', 'date', 'Total', 'balance', 'D/C', 'Description', 'Details'];
const fmt = (d) => d.toISOString().slice(0, 10);

/* Account Statement (/reports/account-statement) — filter form + empty datatable,
   exactly as the reference renders for a fresh account ("No Data Found"). */
export default function ReddyAccountStatementPage() {
  const { user, login } = useReddyAuth();
  useEffect(() => { if (!user) login(); }, [user, login]);

  const [sport, setSport] = useState('ALL');
  const [start, setStart] = useState(() => fmt(new Date(Date.now() - 7 * 86400000)));
  const [end, setEnd] = useState(() => fmt(new Date()));
  const stop = (e) => e.preventDefault();

  return (
    <ReddyLayout>
      <section className="section accounts">
        <div className="row">
          <div className="col-xl-12">
            <h2 className="userscreen-title">account statement</h2>

            <div className="form_search">
              <form noValidate onSubmit={stop}>
                <div className="row">
                  <div className="col-md-2 col-6">
                    <select className="form-control" value={sport} onChange={(e) => setSport(e.target.value)}>
                      <option value="ALL">All Sports</option>
                      {SIDEBAR_ITEMS.map((s) => <option value={s.id} key={s.id}>{s.label}</option>)}
                    </select>
                  </div>
                  <div className="col-md-2 col-6">
                    <input type="date" className="form-control" value={start} onChange={(e) => setStart(e.target.value)} />
                  </div>
                  <div className="col-md-2 col-6">
                    <input type="date" className="form-control" value={end} onChange={(e) => setEnd(e.target.value)} />
                  </div>
                  <div className="col-md-2 col-6">
                    <button type="submit" className="btn btn-fs">get statement</button>
                  </div>
                  <div className="col-md-4 col-12 text-md-end text-center">
                    <div className="document_button" />
                  </div>
                </div>
              </form>
            </div>

            <div className="table-responsive">
              <table className="datatable table table-striped table-bordered">
                <thead>
                  <tr>{COLS.map((c) => <th key={c}>{c}</th>)}</tr>
                </thead>
                <tbody>
                  <tr><td colSpan={COLS.length} className="noData">No Data Found</td></tr>
                </tbody>
              </table>
            </div>

            <nav className="pagination" aria-label="pagination">
              <ul className="pagination pagination-circle justify-content-center">
                <li className="page-item disabled"><a className="page-link" href="javascript:void(0)" onClick={stop}>Previous Page</a></li>
                <li className="page-item disabled"><a className="page-link" href="javascript:void(0)" onClick={stop}>Next Page</a></li>
              </ul>
            </nav>
          </div>
        </div>
      </section>
    </ReddyLayout>
  );
}
